import TrainerStudentEnquiry from '../../features/trainer/TrainerStudentEnquiry'

const TrainerStudentEnquiryPage = () => {
  return <TrainerStudentEnquiry/>
}

export default TrainerStudentEnquiryPage